import { createSlice } from '@reduxjs/toolkit'

export const reportSlice = createSlice({
    name: 'report',
    initialState: {
        details: {},
    },
    reducers: {
        setAllValue: (_, action) => action.payload,
        setValue: (state, action) => {
            const payload = action.payload
            if (!payload || typeof payload !== 'object') return
            Object.keys(payload).forEach(k => {
                state.details[k] = payload[k]
            })
        },
    },
})

export const { setAllValue, setValue } = reportSlice.actions

export default reportSlice.reducer
